import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { URLS } from "../../utils/ApiUrls";
import axios from "axios";
import { errorPopup, successPopup } from "../../utils/ToasterMessage";
import { Images } from "../../utils/images";
import Loader from "../../Component/Loader/Loader";
import './Forgot.css'

export default function OtpVerification() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "",""]);

  const handleOtpChange = (index, value) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 4) {
      document.getElementById(`otp-${index + 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const otpValue = otp.join("");
      await axios
        .post(`${URLS.verifyOtp}`, { otp: otpValue })
        .then((res) => {
          successPopup(res?.data?.message);
          setLoader(false);
          navigate("/reset-password"); 
        })
        .catch((err) => {
          errorPopup(err?.response?.data?.message);
          setLoader(false);
        });
    } catch (error) {
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <Loader />}
      <div className="main_login">
        <div className="left-color-box">
          <div className="login_box">
            <img src={Images.kaamvala_logo} alt="Kaamvala Logo" className="auth-logo" />

            <h1 className="AuthTitle mb-3">Forgot Your Password?</h1>
            <form onSubmit={handleSubmit} className="d-flex flex-column gap-1">
              <div className="input-group">
            <div className="input-label">OTP</div>
             <div className="otp-container">
              {otp.map((digit, index) => (
            <input
        key={index}
        id={`otp-${index}`}
        className="otp-input"
        type="text"
        maxLength="1"
        value={digit}
        onChange={(e) => handleOtpChange(index, e.target.value)}
        onFocus={(e) => e.target.select()}
        onKeyDown={(e) => {
          if (e.key === 'Backspace' && !digit && index > 0) {
            document.getElementById(`otp-${index - 1}`).focus();
          }
        }}
      />
    ))}
  </div>
</div>
              <button className="authbtn mt-3">Log in</button>
              <span
                className="forgotPassword text-center mt-3"
                onClick={() => navigate("/user/login")}
              >
                Back To Login
              </span>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}